import { Component, Type, Input, ViewChild, EnvironmentInjector, ViewContainerRef, ChangeDetectorRef, OnInit, Injector, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { SettingsCustomFormsEditorService } from '@app/services/settings/custom-forms.service';
import { FieldFactoryLocator } from '@core/custom-forms/factories/field-factory-locator';
import { FormsFieldItemMenuClick } from '@core/custom-forms/components/settings-field-menu/field-menu-item.model';
import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";

@Component({
    selector: 'app-settings-custom-forms-dynamic-field-host',
    template: '<ng-template #dynamicSettingsFieldContainer></ng-template>',
})
export class SettingsDynamicFieldHostComponent implements OnInit, OnChanges, OnDestroy {
    @Input() field: SettingsCustomFormFieldData;
    @Output() fieldChange = new EventEmitter<SettingsCustomFormFieldData>();
    @Output() menuClick = new EventEmitter<FormsFieldItemMenuClick>();
    @ViewChild('dynamicSettingsFieldContainer', { read: ViewContainerRef, static: true }) dynamicSettingsFieldContainer: ViewContainerRef;

    protected componentType: Type<any>;
    protected componentRef: any;
    protected dependencies: SettingsCustomFormFieldData[] = [];
    private subs: Subscription[] = [];
    constructor(public viewContainerRef: ViewContainerRef,
        private injector: Injector,
        private cdr: ChangeDetectorRef,
        private formsEditorSrv: SettingsCustomFormsEditorService,
        private fieldLocator: FieldFactoryLocator,
        private environmentInjector: EnvironmentInjector) { }

    ngOnInit() {
        this.loadComponent();

        if (this.field.type === 'artwork-link-selector-v1') {
            this.subs.push(
                this.formsEditorSrv.selectAwLinkRelatedFields().subscribe((relatedFields: SettingsCustomFormFieldData[]) => {
                    const dependenciesChanged = this.dependencies.length !== relatedFields.length ||
                        this.dependencies.some((dependency, index) =>
                            dependency.label !== relatedFields[index].label
                        );

                    if (dependenciesChanged) {
                        this.dependencies = [...relatedFields];
                        this.dynamicSettingsFieldContainer.clear();
                        this.loadComponent();
                    }
                })
            );
        }

    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.field && !changes.field.isFirstChange()) {
            // detect if field type in this position to create a new component in place of the old one.
            // replace components in same position without cleaning the container ref does not work 
            if (changes.field.previousValue.type != changes.field.currentValue.type ||
                changes.field.previousValue.id != changes.field.currentValue.id
            ) {
                this.dynamicSettingsFieldContainer.clear();
                this.loadComponent();
            } else {
                this.updateField(); // maybe need to update the field, but seems to work.
            }
        }
    }

    ngOnDestroy(): void {

        this.subs.forEach((sub: Subscription) => sub.unsubscribe());
        // Clean up the created component and instance
        this.componentType = null;
    }

    private loadComponent() {
        const fieldFactory = this.fieldLocator.get(this.field.type);
        this.componentType = fieldFactory.getSettingsComponentType();
        this.componentRef = this.dynamicSettingsFieldContainer.createComponent(this.componentType, {
            injector: this.injector,
            environmentInjector: this.environmentInjector
        });

        this.updateField();
        if (this.field.type === 'artwork-link-selector-v1') {
            this.updateDependencies();
        }
        // Listen to changes from the component and emit them
        (this.componentRef.instance as any).fieldChange.subscribe((updatedField: SettingsCustomFormFieldData) => {
            this.fieldChange.emit(updatedField);
        });
        (this.componentRef.instance as any).menuClick.subscribe((item: FormsFieldItemMenuClick) => {
            this.menuClick.emit(item);
        });
    }

    updateField() {
        if (this.componentRef) {
            (this.componentRef.instance as any).field = this.field;
        }
    }

    updateDependencies() {
        if (this.componentRef) {
            this.componentRef.instance.dependencies = this.dependencies;
        }
    }
}